/**
 * Scheme-code-driven configuration for performance views.
 *
 * Schemes whose returns are denominated in something other than INR. Add a
 * `SCHEME_CODE: 'CCY'` entry and every performance table using <SchemePerfBadges />
 * surfaces the currency badge for that scheme.
 *
 * This lives in the frontend because the backend has no `Scheme.currency` field yet.
 * Once it does, drop this map and read the currency off the scheme payload instead.
 */
export const SCHEME_RETURN_CURRENCY: Record<string, string> = {
    SIFEF: 'USD',
};
